import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';


import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import { styled } from '@mui/system'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';




export default class AddCategory extends Component {
constructor(props) {
    super(props);
	
	 this.state = {caid:'',open:false,data:[],redirect: false,details:'',btndisabled:false,submitbtn:"Submit",
pagename:'',name:"",categoryarray:[],maincategory:0,category:'',ca_id:0,categorylabel:'Category',

      }
   
}

componentWillMount() {
	this.Categorygetdata();
}

onloadcategorybind(){

    axios.get(localStorage.getItem("ISIurl")+"ajaxcategory.php?action=getall&ca_mainId=0&ca_cmp_id="+localStorage.getItem("ISIcmpid"))
     .then((response) =>{    
     
  let roleFromApi = response.data.map(maincategory => {
                          
          return {value:maincategory.ca_id, display:maincategory.ca_name}
        });
      this.setState({
          categoryarray: [{value:'0',display:'Main Category'}].concat(roleFromApi)
        });
      })   
    
      


}


 Categorygetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(localStorage.getItem("ISIurl")+'ajaxcategory.php?action=getall&ca_cmp_id='+localStorage.getItem("ISIcmpid")+'&ca_id='+this.props.id)
  .then(resp => {  
	if(resp.data.length>0){
    this.setState({ 
        ca_id:resp.data[0].ca_id,
		name:resp.data[0].ca_name,
		maincategory:resp.data[0].ca_mainId,
	});
	
  }

});
	  
  }else{
	 this.setState({  
	  ca_id:0,
		name:'',
		maincategory:0,
		

	  }); 
 }
 
   this.onloadcategorybind();
    }
	








myChangeHandler = (event) => {
 
   const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;

if(nam==="ca_id")
{

 this.setState({[nam]: val},()=>{});

}	else{
  this.setState({[nam]: val},()=>{});
  }

  
}


onclickclose=(event)=>{
	  
	this.setState({ ca_id:0,name:'',		maincategory:0,btndisabled:false,submitbtn:"Submit"});  
  }

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


  handleSubmit= (event) => {
	

    event.preventDefault();
	
	let name=this.state.name;
	let maincategory=this.state.maincategory;
	
	

		
if(name==="")
{
	this.setState({errormessage:"Please Enter Category",erropen:true});
	return false;
}



this.setState({btndisabled:true,submitbtn:"Processing...",errormessage:'',erropen:false})
	 var formData = new FormData();

	  
	 if(this.state.ca_id!=="")
	 {
	  
	  formData.append('ca_id',this.state.ca_id)
	 }else
	 {
		formData.append('ca_id',0)  
	 }
	 formData.append('action','insertupdate')
     formData.append('ca_name',name)
	 formData.append('ca_mainId',maincategory)
	 formData.append('ca_cmp_id',localStorage.getItem("ISIcmpid"))
	 formData.append('userid',localStorage.getItem("ISIuserid"))
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcategory.php", formData,{
        }).then(res => {
			
			 if(res.data=="-1")
{ 
	this.setState({errormessage:"Category  Already Exist.",btndisabled:false,submitbtn:"Submit",erropen:true})
	 

	}else{this.setState({
		 ca_id:0,
		name:'',
		maincategory:0,})
		this.onloadcategorybind();
		this.props.updatecategory();
	}
	
   });   

this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });   
  };
  
  render() { 
  
   const { ...props } = this.props;

  
  return (
 
		<React.Fragment>

    

<div className="formlist">
<p><Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
           
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    

	
<div className="formmain">
<p>Name <span className="validation">*</span></p>
<p>
		<TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
 

		<p>Main Category </p>
		  <p><FormControl  className="txtbox" >
		
       <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{label:this.state.categorylabel,value:this.state.maincategory}}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.maincategory}
		  name="maincategory"
		
		
        >
		{this.state.categoryarray.map(maincategory => (
            <option  
            
              value={maincategory.value}
            >
              {maincategory.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
</div>


		  
		  
		   
		 

 
  
		   <br/>
        <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" disable={this.state.btndisabled} className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>	
	 
						    
	
</React.Fragment>
  );
  }
}